import { throttle } from 'lodash';

(function () {
  'use strict';

  const header = document.getElementById('header-rebrand');
  const stickyClass = 'header-rebrand--sticky';

  function toggleStickyHeader() {
    if (window.scrollY > 0) {
      header.classList.add(stickyClass);
    } else {
      header.classList.remove(stickyClass);
    }
  }

  if (header) {
    const delay = 500;
    window.addEventListener('resize', throttle(toggleStickyHeader, delay));
    window.addEventListener('scroll', throttle(toggleStickyHeader, delay));
  }
})();
